<footer class="sigma_footer style-3 sigma_footer-dark pb-0">
    <div class="sigma_footer-middle">
        <div class="container">
            <div class="row">
                <div class="col-lg-2 col-sm-4">
                    <div class="sigma_footer-widget">
                        <h5 class="widget-title">Solutions</h5>
                        <ul class="sigma_footer-links">
                            <li>
                                <a routerLink="/services">Services</a>
                            </li>
                            <li>
                                <a routerLink="/case-studies">Portfolio</a>
                            </li>
                            <li>
                                <a routerLink="/shop">Ecommerce</a>
                            </li>
                            <li>
                                <a routerLink="/team">Team</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                    <div class="sigma_footer-widget">
                        <h5 class="widget-title">Company</h5>
                        <ul class="sigma_footer-links">
                            <li>
                                <a routerLink="/">Home</a>
                            </li>
                            <li>
                                <a routerLink="/about">About</a>
                            </li>
                            <li>
                                <a routerLink="/blog-grid">Blog</a>
                            </li>
                            <li>
                                <a routerLink="/contact">Contacts</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                    <div class="sigma_footer-widget">
                        <h5 class="widget-title">Legal</h5>
                        <ul class="sigma_footer-links">
                            <li>
                                <a routerLink="/contact">Help</a>
                            </li>
                            <li>
                                <a routerLink="/faqs">Faq</a>
                            </li>
                            <li>
                                <a routerLink="/pricing">Pricing</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="sigma_footer-widget">
                        <div class="sigma_footer-logo mb-4">
                            <img src="assets/img/logo-2.png" alt="logo">
                        </div>
                        <h5 class="widget-title">Subscribe To Our Newsletter</h5>
                        <form>
                            <div class="row">
                                <div class="col-md-8">
                                    <input type="email" name="email" class="form-control" placeholder="Enter your email" required>
                                </div>
                                <div class="col-md-4">
                                    <button type="button" class="sigma_btn-custom btn-block mt-4 mt-md-0">Submit</button>
                                </div>
                            </div>
                            <span>* Nulla porttitor accumsan tincidunt.</span>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="sigma_footer-bottom mt-0 d-block d-sm-flex align-items-center justify-content-between">
            <div class="sigma_footer-copyright m-0">
                <p class="mb-0"> &copy; Website -
                    <a href="#">2021</a>
                </p>
            </div>
            <ul class="sigma_sm square mt-3 mt-sm-0 justify-content-center justify-content-sm-start">
                <li>
                    <a href="#"><i class="fab fa-facebook-f"></i></a>
                </li>
                <li>
                    <a href="#"><i class="fab fa-twitter"></i></a>
                </li>
                <li>
                    <a href="#"><i class="fab fa-instagram"></i></a>
                </li>
            </ul>
        </div>
    </div>
</footer>